/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PolicyEvaluation
 */
export interface PolicyEvaluation {
	/**
	 * Indicates if the policy is enabled
	 * @type {boolean}
	 * @memberof PolicyEvaluation
	 */
	enabled: boolean;
}

/**
 * Check if a given object implements the PolicyEvaluation interface.
 */
export function instanceOfPolicyEvaluation(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'enabled' in value;

	return isInstance;
}

export function PolicyEvaluationFromJSON(json: any): PolicyEvaluation {
	return PolicyEvaluationFromJSONTyped(json, false);
}

export function PolicyEvaluationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PolicyEvaluation {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		enabled: json['enabled'],
	};
}

export function PolicyEvaluationToJSON(value?: PolicyEvaluation | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		enabled: value.enabled,
	};
}
